var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wrapper"}},[_c('div',{attrs:{"id":"login"}},[_c('div',{staticClass:"container-fluid"},[_c('h4',{staticClass:"text-center"},[_vm._v("Login")])])])])
}]

export { render, staticRenderFns }